// extracted by mini-css-extract-plugin
export default {"divider":"mochi-divider_divider__Wopxi"};